import { createUseStyles } from 'react-jss';
import { alertColors, texts } from '../../utils/theme';

export default createUseStyles({
  upload: {
    '& .ant-upload': {
      width: '100%',
      maxWidth: '100%',
    },
  },
  triangleExclamation: {
    '& svg': {
      width: '18px',
      height: '18px',
      '& path': {
        fill: alertColors.danger,
      },
    },
  },
  xMark: {
    padding: '0px !important',
    minWidth: '24px !important',
    '& svg': {
      width: '10px',
      height: '10px',
      '& path': {
        fill: texts.text2,
      },
    },
  },
  buttonWithIcon: {
    '& svg': {
      width: '16px',
      height: '16px',
    },
  },
});
